import { render, staticRenderFns } from "./tab-empresa.vue?vue&type=template&id=44c339be&scoped=true&"
import script from "./tab-empresa.vue?vue&type=script&lang=js&"
export * from "./tab-empresa.vue?vue&type=script&lang=js&"
import style0 from "./tab-empresa.vue?vue&type=style&index=0&id=44c339be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c339be",
  null
  
)

export default component.exports